var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteButtonDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4277,
    cy: 24.4277,
    r: 24.4277,
    fill: "#D3D3D3",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 33.9367L16.6319 26.0289L16.6319 26.0289L15.2711 24.6613C13.2429 22.6219 13.2431 19.3152 15.271 17.2771C17.2968 15.2411 20.5806 15.2409 22.6078 17.2771C22.6078 17.2771 22.6079 17.2772 22.6079 17.2772L23.9686 18.6447L24.5003 19.1791L25.0319 18.6447L26.3927 17.2772C26.3927 17.2772 26.3928 17.2771 26.3928 17.2771C28.4046 15.2563 31.6539 15.2412 33.6831 17.231L33.7289 17.277C35.757 19.3158 35.757 22.6225 33.7289 24.6613L32.3681 26.0289L24.4997 33.9367Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteButtonDisabled);
export default __webpack_public_path__ + "static/media/FavouriteButtonDisabled.b317689ad843933dd179c9723219dcaa.svg";
export { ForwardRef as ReactComponent };